import {
  HttpEvent,HttpInterceptor,HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse, HttpContextToken

} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, tap, first, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { QuickBooksService } from '@app/modules/quick-books/services/quick-books.service';

// Set to true on a request to suppress the interceptor's automatic toasts
// (server-driven success toastr and 400 error toastr). Used by bulk flows
// that fire many requests and show a single aggregated toast instead.
export const SUPPRESS_TOASTR = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})

export class HttpErrorInterceptor implements HttpInterceptor {
  public errorMessage$;
  public isQuickBooksRefreshing$: boolean = false;

  constructor(
    private _router:Router,
    private _toastr: ToastrService,
    public _translation: TranslateService,
    private _quickBooks: QuickBooksService
    ) { }
    
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const suppressToastr = request.context.get(SUPPRESS_TOASTR);

    return next.handle(request)

      .pipe(
        catchError((error: HttpErrorResponse) => {
          if(error instanceof HttpErrorResponse && error.url.includes('api/quick-books')){
            return null;//this.handleQuickBooks401(request, next);
          }

          if(error.status == 400 && !suppressToastr){
            this._toastr.error(this._translation.instant(error.error.message));
          }

          // A 403 without the API's JSON body comes from the firewall in front
          // of the server, which blocks some search text (quotes, SQL words).
          // The API's own 403s carry a message and are handled by the caller.
          if(error.status == 403 && !suppressToastr && !error.error?.message){
            this._toastr.error(this._translation.instant('errormessage.requestBlocked'));
          }

          return throwError(() => error);
        }),
        tap((event: HttpResponse<any>) => {
          if(event.status == 200 || event.status == 202){
            if(event.body?.data?.toastr && !suppressToastr){
              this._translation.get(event.body?.data.toastr.key, event.body?.data.toastr.params)
              .pipe(first()).subscribe(translations => { 
                // A completed delete is a success too; it used to be shown on
                // the red error toast (type: remove), which read as a failure.
                this._toastr.success(translations);
              });
            }
          }
        })
      )
  }

  private handleQuickBooks401(request: HttpRequest<any>, next: HttpHandler){
    if(!this.isQuickBooksRefreshing$){
      this.isQuickBooksRefreshing$ = true;
      const token = this._quickBooks.refreshToken();

      if(token){
        return this._quickBooks.getRefreshToken(token).pipe(
          switchMap(({ data }) => {
            this._quickBooks.setAccessToken(data.accessToken);
            this._quickBooks.setRefreshToken(data.refreshToken);
            return next.handle(this.addQuickBooksTokenHeader(request, data.accessToken));
          }),
          catchError((error) => {
            this.isQuickBooksRefreshing$ = false;
            this._toastr.error(this._translation.instant('quickbooks.error_http'), '', { timeOut: 10000 });
            // localStorage.removeItem('trakrCountingQbAccessToken');
            // localStorage.removeItem('trakrCountingQbRefreshToken');
            // localStorage.removeItem('trakrCountingRealmId');
            return throwError(() => error);
          })
        )
      }
    }
  }

  private addQuickBooksTokenHeader(request: HttpRequest<any>, token: string) {
    return request.clone({ headers: request.headers.set('trakrCountingQbAccessToken', token) });
  }
}